import React, {useEffect} from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {useAuthState, useLoadUserInfo} from '@/store/auth-slice';
import {useGlobalAction, useGlobalState} from '@/store/global-slice';
import MaskLoading from '@/component/mask-loading';
import UserAuth from '@/component/user-auth';
import UserLogin from '@/component/user-login';
import LoadState from '@/common/load-state';
import AllModule from '@/model/all-module';
import Home from '@/pages/home';
import NotFound from '@/pages/not-found';
import NavigationMenu from '@/component/navigation-menu';
import useDeviceFeature from '@/hooks/use-device-feature';
import './app.scss';
import AuthUtil from '@/util/auth-util';
import UserLoad from '@/component/user-load';

const AppWithAuth = (props: {loading: boolean}) => {
    const {userLoadState, user} = useAuthState();
    const {loadUserInfo} = useLoadUserInfo();
    const {reload} = useGlobalAction();
    const {isPhone} = useDeviceFeature();

    useEffect(() => {
        if (userLoadState === LoadState.INIT) {
            loadUserInfo();
        }
    }, [userLoadState, loadUserInfo]);

    useEffect(() => {
        if (userLoadState === LoadState.LOADED && !user) {
            AuthUtil.setReturnUrl(window.location.href);
            window.history.replaceState(undefined, '', '/login');
            reload();
        }
    }, [reload, userLoadState, user]);

    const renderRouter = () => {
        return (
            <Router>
                <NavigationMenu />
                <Routes>
                    <Route path="/" element={<Home />} />
                    {AllModule.flatMap((module) => module.pages.map((page) => <Route key={page.path} path={page.path} element={<page.element />} />))}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Router>
        );
    };

    return (
        <div className="app-container">
            <div className="content-container" id="app-content-container">
                <UserLoad>
                    <div className={`content-container-wrap ${isPhone ? 'content-container-wrap-phone' : ''}`}>{renderRouter()}</div>
                </UserLoad>
            </div>
            <MaskLoading loading={props.loading} />
        </div>
    );
};

const NO_AUTH_MAP: {[key: string]: JSX.Element} = {
    '/login': <UserLogin />,
    '/auth': <UserAuth />,
};

const App = () => {
    const pn = window?.location?.pathname;
    const p = pn.length > 1 && pn.endsWith('/') ? pn.substring(0, pn.length - 1) : pn;
    const {isLoading} = useGlobalState();

    if (NO_AUTH_MAP[p]) {
        return (
            <div className="app-container">
                <div className="content-container">{NO_AUTH_MAP[p]}</div>
            </div>
        );
    } else {
        return <AppWithAuth loading={isLoading} />;
    }
};

export default App;
